import ons from "onsenui";

export function getPlatform(): string {
  if (ons.platform.isIOS()) {
    return "iOS";
  } else if (ons.platform.isAndroid()) {
    return "Android";
  } else {
    return "Unknown";
  }
}
